import { render, staticRenderFns } from "./industData.vue?vue&type=template&id=48c5df12&scoped=true"
import script from "./industData.vue?vue&type=script&lang=js"
export * from "./industData.vue?vue&type=script&lang=js"
import style0 from "./industData.vue?vue&type=style&index=0&id=48c5df12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c5df12",
  null
  
)

export default component.exports